import React from "react";
import PropTypes from "prop-types";
import Icon from "components/icon";
import IconButton from "components/icon-button";

const DeleteCardButton = ({ onDelete }) => (
  <IconButton onClick={onDelete}>
    <Icon name="delete" />
  </IconButton>
);

DeleteCardButton.propTypes = {
  /**
   * Función que se invoca al eliminar el contacto del formulario
   */
  onDelete: PropTypes.func,
};

export default DeleteCardButton;
